<template>
  <div class="container">
    <div class="header-bottom">
      <nav class="navbar navbar-expand-lg navbar-light header-sticky">
          <img class="logo-light" src="../../assets/images/logo.png" alt="logo Benichy" width="100px;"/>
          
        

        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="icon-bar top-bar"></span>
          <span class="icon-bar middle-bar"></span>
          <span class="icon-bar bottom-bar"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mx-auto">
            <li class="nav-item">
              <a
                class="nav-link"
                href="../#hero"
                :class="{ active: activeId === 'home' }"
                @click="setActive('home')"
              >
                Inicio
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="../#convenios"
                :class="{ active: activeId === 'service' }"
                @click="setActive('service')"
              >
                Convenios
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="../#aseguradoras"
                :class="{ active: activeId === 'gallery' }"
                @click="setActive('gallery')"
              >
                Aseguradoras
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="../#lentes"
                :class="{ active: activeId === 'team' }"
                @click="setActive('team')"
              >
                Seguridad
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="../#clientes"
                :class="{ active: activeId === 'pricing' }"
                @click="setActive('pricing')"
              >
                Clientes
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="../#contacto"
                :class="{ active: activeId === 'contact' }"
                @click="setActive('contact')"
              >
                Contacto
              </a>
            </li>
            
          </ul>
        </div>

        
      </nav>
    </div>
  </div>
  <div class="search-area" :class="{ open: toggler }">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <button
            type="button"
            class="close-searchbox"
            @click="toggler = !toggler"
          >
            <i class="ri-close-line"></i>
          </button>
          <form action="#">
            <div class="form-group">
              <input type="search" placeholder="Search Here" autofocus="" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainNavbar",
  data() {
    return {
      activeId: null,
      toggler: false,
      button_toggler_state: false,

      show: false,
      active: false,
      button_show_state: false,
      newData: [
        {
          id: "1",
          image: require("../../assets/images/uk.png"),
          name: "English",
        },
        {
          id: "2",
          image: require("../../assets/images/china.png"),
          name: "简体中文",
        },
        {
          id: "3",
          image: require("../../assets/images/uae.png"),
          name: "العربيّة",
        },
      ],
      name: "English",
      image: require("../../assets/images/uk.png"),
      clicked: false,
    };
  },
  methods: {
    toggleSelected(select, index) {
      if (this.clicked === index) {
        this.clicked = null;
      }

      this.clicked = index;
      this.name = select.name;
      this.image = select.image;
    },
    setActive(id) {
      this.activeId = id;
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar-toggler {
  border: none;
  padding: 7px;
  border-radius: 0;

  .icon-bar {
    width: 28px;
    transition: all 0.3s;
    background: var(--clr_redical);
    height: 2px;
    display: block;
  }
  .top-bar {
    transform: rotate(0);
    left: 0;
  }
  .middle-bar {
    opacity: 1;
    margin: 6px 0;
  }
  .bottom-bar {
    transform: rotate(0);
    left: 0;
  }
  &[aria-expanded="true"] {
    .top-bar {
      transform: rotate(45deg);
      transform-origin: 10% 10%;
      left: 4px;
      position: relative;
    }
    .middle-bar {
      opacity: 0;
      margin: 6px 0;
    }
    .bottom-bar {
      transform: rotate(-45deg);
      transform-origin: 10% 90%;
      left: 4px;
      position: relative;
    }
  }
}
.select-lang {
  .navbar-language {
    .dropdown-toggle {
      position: relative;
      img {
        width: 20px;
      }
      &::before {
        right: -5px;
      }
    }
  }
}
</style>